// extracted by mini-css-extract-plugin
export default {"imageBlock":"ImageBlock_imageBlock__RnW+a","imageText":"ImageBlock_imageText__o2STC"};